import http from '@/utils/services/http'

export function cadastrarGev (data, id) {
  if (id) return atualizarGev(data, id)
  return http.post(`/api/policiacivil/gev`, data)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function atualizarGev (data, id) {
  return http.patch(`/api/policiacivil/gev/${id}`, data)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function findGev (id) {
  return http.get(`/api/policiacivil/gev/${id}`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}



// WEBPACK FOOTER //
// ./src/domain/policia-civil/gev/services/gev.js